import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  basicHeader: {
    justifyContent: 'initial'
  },
  basicLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
export default useStyles;